export default {
  basketItems: [],
};
